import apiService from "./apiService";

export const getAllRestaurants = () => apiService.get("/restaurants");
export const getRestaurantById = (id) => apiService.get(`/restaurants/${id}`);
export const createRestaurant = (data) => apiService.post("/restaurants", data);
export const updateRestaurant = (id, data) =>
  apiService.put(`/restaurants/${id}`, data);
export const deleteRestaurant = (id) => apiService.delete(`/restaurants/${id}`);
